/**
 * hardReload — wymuszenie wgrania świeżej wersji apki niezależnie od cache,
 * ciasteczek SW, czy starej wersji w pamięci. Używane jako fallback gdy zwykły
 * F5 nie pomógł (np. SW utknął w starej wersji, browser cache zatrzymał JS).
 *
 * Steps:
 *   1) unregister każdy SW z origin
 *   2) wyczyść wszystkie Cache Storage entries (workbox precache + runtime)
 *   3) reload z param ?_=timestamp (busts HTTP-cache index.html mimo no-store)
 */
export async function hardReload(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (err) {
    console.warn('[hardReload] SW unregister failed:', err);
  }
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (err) {
    console.warn('[hardReload] caches clear failed:', err);
  }
  // Cache-busting query param — gwarantuje że proxy/CDN zwróci świeży index.html
  const base = window.location.pathname.replace(/\/+$/, '') || '/';
  const ts = Date.now();
  const hash = window.location.hash || '';
  window.location.replace(`${base}?_=${ts}${hash}`);
}
